export default __webpack_public_path__ + "static/concert-logo-b5d47deb0c9be8c05af373cbe5b91a81.png";